import React from 'react';
import '../styling/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2025 FlushFinder. All rights reserved.</p>
        </footer>
    );
};

export default Footer;